// Les quatre sons de Koinonia.
//
// ⚠️ ILS SONT FABRIQUÉS, PAS EMPRUNTÉS. Ceux de Messenger appartiennent à
// Meta. Les nôtres sont écrits de zéro par `outils/fabriquer-sons.mjs` —
// c'est là qu'on change une note, jamais dans les fichiers `.wav` eux-mêmes,
// qui sont régénérés.
//
// ⚠️ ET ILS SE TAISENT SUR DEMANDE. Un son qu'on ne peut pas éteindre finit
// par faire éteindre l'application entière. Le réglage vit dans le navigateur,
// pas en base : c'est un choix d'APPAREIL, pas de compte — on ne veut pas la
// même chose sur son téléphone et sur l'ordinateur du bureau.

const CLE = "kn.sons";

/* ⚠️ UN LECTEUR PAR SON, CRÉÉ UNE SEULE FOIS. En créer un à chaque fois
   marcherait, mais le navigateur téléchargerait le fichier à chaque coup et le
   son arriverait en retard — après le geste qu'il devait accompagner. */
const lecteurs = new Map();

/* ⚠️ LE VOLUME EST BAS, ET C'EST DÉLIBÉRÉ. Ces sons accompagnent un geste ;
   ils ne l'annoncent pas. À plein volume, ils deviennent une gêne dans une
   salle de culte — l'endroit exact où cette application est ouverte. */
const VOLUMES = { envoye: 0.35, recu: 0.5, alerte: 0.6, ouvert: 0.25 };

/** Le membre veut-il des sons ? Oui, tant qu'il n'a pas dit le contraire. */
export function sonsActifs() {
  try {
    return localStorage.getItem(CLE) !== "non";
  } catch {
    return true;
  }
}

export function reglerSons(actifs) {
  try {
    localStorage.setItem(CLE, actifs ? "oui" : "non");
  } catch {
    // navigation privée : le réglage ne survivra pas, tant pis
  }
}

/* ⚠️ DEUX SONS IDENTIQUES COUP SUR COUP FONT DU BRUIT, PAS DU SENS. Recevoir
   dix messages d'un coup — ce qui arrive quand on rouvre l'application après
   une heure — ne doit pas jouer dix fois la même note. On laisse passer le
   premier et l'on ferme la porte un court instant. */
const dernierCoup = new Map();
const REPOS = { envoye: 120, recu: 900, alerte: 900, ouvert: 400 };

/**
 * Joue un son. Ne rend rien, n'attend rien, ne lève jamais.
 *
 * ⚠️ IL PEUT ÊTRE REFUSÉ, ET CE N'EST PAS UNE PANNE. Un navigateur n'autorise
 * le son qu'après un premier geste du membre sur la page. Avant cela, la
 * promesse est rejetée en silence — c'est voulu par les navigateurs, et il n'y
 * a rien à réparer.
 */
export function jouer(nom) {
  if (!VOLUMES[nom] || !sonsActifs()) return;

  const maintenant = Date.now();
  if (maintenant - (dernierCoup.get(nom) || 0) < REPOS[nom]) return;
  dernierCoup.set(nom, maintenant);

  try {
    let lecteur = lecteurs.get(nom);
    if (!lecteur) {
      lecteur = new Audio(`sons/${nom}.wav`);
      lecteur.volume = VOLUMES[nom];
      lecteur.preload = "auto";
      lecteurs.set(nom, lecteur);
    }
    lecteur.currentTime = 0;
    lecteur.play?.().catch(() => {});
  } catch {
    // pas de son : jamais une raison d'interrompre quoi que ce soit
  }
}
